module.exports = __webpack_public_path__ + "img/faq.9c37fad9.png";